import { Place } from '@/types';
import { GigPigWidget } from '@/ui';
import { getChannel, getDocument, getPlaceId } from '@lib/server';
import tinycolor from 'tinycolor2';

import { BlockBase, Wrapper } from './utils';

export async function GigPig({ id, params }: BlockBase) {
  const channel = await getChannel(decodeURIComponent(params.domain));
  if (!channel) {
    return null;
  }

  const { colors } = channel?.themeConfig || {};

  if (!params.venue) {
    return null;
  }

  const { placeId } = await getPlaceId(channel, decodeURIComponent(params.venue));

  if (!placeId) {
    return null;
  }

  const place = await getDocument<Place>('place', placeId, {
    select: ['fields.name', 'fields.apps'],
    tags: [channel.channelId],
    depth: 0,
  });

  const gigPigId = place?.fields?.apps?.gigPig.id;

  if (!gigPigId) {
    return null;
  }

  const dark = tinycolor(colors?.card).isDark();

  return (
    <Wrapper id={id} className="max-w-(--breakpoint-xl)! flex-col">
      <GigPigWidget
        widgetKey={gigPigId}
        foregroundColour={colors?.cardForeground}
        backgroundColour={colors?.card}
        dark={dark}
      />
    </Wrapper>
  );
}
